module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAQ5JREFUKBVjYCABXL16VeXatWs6IC1MxOoDagpjZmY+xsjI6AbSw0iMRqAtmUANk4CYBaj+yM+fPz1ADLwAqCmOiYlpClAR0////98B6cdAvgRc05kzZ7jgHCgDqMnuxo0b34D4//Xr12devHhREaaG5fz58wIcHBxdQAGQxhiYBFCxFNCGRUD8BygWpampuRwmB6KZgJo0gW6PA+IooGJHkGBDQwPIWdOBYoJArh+6JpAaMAA6yRvkJKBzjoMEgHQaEP8EhqQzRAUmCQ9VoMYkoPTcf//+tQJtArErgTYtxNSCRQSoeTEQgwKiD4s0ihBKdPz586cHGMnSv379qkVRRYgDjBJWoL8QcYRHAwDe/nZPKOUReAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coo/icon_xuanzhong2.png
// module id = cV+u
// module chunks = 2